const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          useAll: true,
        },
      },
      {
        component: "search-start-end",
        label: "자체개선 요청기한",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "발생 사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["연도", "발생 사업장", "발생일", "자체점검 요청기한", "자체개선 요청기한", "수검 사업장 개선조치", "당진공장", "중앙기술연구소", "포항공장", "인천공장", "경영책임자 보고"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    if (year) {
      conditions.push({key: 'body.발생일', operator: '>=', value: `${year}-01-01`})
      conditions.push({key: 'body.발생일', operator: '<', value: `${year + 1}-01-01`})
    }

    //  작성일
    if (search.date) {
      conditions.push({ key: "body.자체개선요청기한", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "body.자체개선요청기한", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "연도",
        key: "body.발생일",
      },
      {
        name: "발생 사업장",
        key: "body.stdInfo.field_name",
        style: { maxWidth: "120px" },
      },
      {
        name: "기관",
        key: "body.기관",
      },
      {
        name: "점검사유",
        key: "body.점검사유",
      },
      {
        name: "주요 점검내용",
        key: "body.주요_점검내용",
      },
      {
        name: "점검일(발생일)",
        key: "body.발생일",
        style: { minWidth: "120px" },
      },
      {
        name: "자체점검 요청기한",
        key: "body.자체점검요청기한",
      },
      {
        name: "자체개선 요청기한",
        key: "body.자체개선요청기한",
      },
      {
        name: "수검 사업장 개선조치",
        key: "body.수검사업장개선조치",
      },
      {
        name: "인천공장",
        key: "body.개선조치현황[0].progress",
      },
      {
        name: "포항공장",
        key: "body.개선조치현황[1].progress",
      },
      {
        name: "당진공장",
        key: "body.개선조치현황[2].progress",
      },
      {
        name: "중앙기술연구소",
        key: "body.개선조치현황[3].progress",
        style: { minWidth: "125px" },
      },
      {
        name: "경영책임자 보고",
        key: "body.경영책임자_보고",
        style: { minWidth: "125px" },
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: { // 발생년도
          const date = func.getContent(value).발생일;
          if (date && date.length >= 4) {
            return date.substring(0, 4);
          }
        }
        case 1:
          return func.getContent(value).stdInfo.field_name; // 발생 사업장
        case 2:
          return func.getContent(value).기관; // 기관
        case 3:
          return func.getContent(value).점검사유; // 점검사유
        case 4:
          return func.getContent(value).주요_점검내용; // 주요 점검내용
        case 5:
          return func.getContent(value).발생일; // 발생일
        case 6:
          return func.getContent(value).자체점검요청기한; // 자체점검요청기한
        case 7:
          return func.getContent(value).자체개선요청기한; // 자체개선요청기한
        case 8: {
          // 수검사업장개선조치
          const data = func.getContent(value).수검사업장개선조치;
          return {
            type: "html",
            html: `<span style='color: ${data === "미완료" ? "#EA5455" : "#28C76F"}'>${data}</span>`,
          };
        }
        case 9:
          return func.getContent(value).개선조치현황[0].progress; // 인천공장
        case 10:
          return func.getContent(value).개선조치현황[1].progress; // 포항공장
        case 11:
          return func.getContent(value).개선조치현황[2].progress; // 당진공장
        case 12:
          return func.getContent(value).개선조치현황[3].progress; // 중앙기술연구소
        case 13: {
          // 경영책임자 보고
          let data = func.getContent(value).경영책임자_보고;
          if (data === "완료" && func.getContent(value).보고일 !== "") {
            const date = func.getContent(value).보고일;
            data = `${data}<br/>(${date})`;
          }

          return {
            type: "html",
            html: `<span style='color: ${data === "미완료" ? "#EA5455" : "#28C76F"}'>${data}</span>`,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
